export enum PatientFormOptions {
  phq9 = 'PHQ9',
  covidScreen = 'COVID Screen',
  asthmaControlTest = 'Asthma Control Test',
  gad7 = 'GAD-7',
}
